
import { mapGetters } from "vuex";

export default {
  name: "CancelarVenda",

  data: () => ({
    dialog: false,
    loading: false,
    motivoCancelamento: "",
  }),

  props: {
    id: Number,
    modo: {
      default: "analise",
      type: String,
    },
  },

  computed: {
    ...mapGetters("usuario", { usuario: "getUsuario" }),
  },

  methods: {
    deletaVenda() {
      this.loading = true;
      this.$http
        .delete(`/venda/${this.id}`, {
          userID: this.usuario.id,
          userName: this.usuario.nome,
        })
        .then(() => {
          this.$emit("cancelado");
        })
        .catch((error) => {
          alert(`Ocorreu um erro ao apagar esta venda,\n
                  verifique sua conexão com a internet: ${error}`);
        })
        .finally(() => {
          this.dialog = false;
          this.loading = false;
        });
    },

    solicitaCancelamentoDavenda() {
      this.loading = true;
      this.$http
        .put(`/venda/status/${this.id}`, {
          obs: this.motivoCancelamento,
          status: "aguardando cancelamento",
          userID: this.usuario.id,
          userName: this.usuario.nome,
        })
        .then(() => {
          this.$emit("cancelado");
        })
        .catch((error) => {
          alert(`Ocorreu um erro ao apagar esta venda,\n
                  verifique sua conexão com a internet: ${error}`);
        })
        .finally(() => {
          this.dialog = false;
          this.loading = false;
        });
    },
  },
};
